// app/javascript/controllers/dashboard/analyzer_controller.js
import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
    connect() {
        console.log("Analyzer controller connected!")
    }

    selectDocument(event) {
        console.log("selectDocument called!", event.currentTarget)
        event.preventDefault()
        const documentItem = event.currentTarget
        const documentToken = documentItem.getAttribute('data-token')
        const href = documentItem.getAttribute('data-href') || `/dashboard/document/${documentToken}`
        
        if (href) {
            Turbo.visit(href)
        }
    }

    toggleIndicator(event) {
        console.log("toggleIndicator called!")
        event.preventDefault()
        const indicator = event.currentTarget.closest('.document-app__indicator')
        const content = indicator.querySelector('.document-app__indicator-content')
        console.log('indicator:', indicator)
        console.log('content:', content)

        content.style.display = content.style.display === 'none' ? 'block' : 'none'
    }

    switchTab(event) {
        console.log("switchTab called!")
        event.preventDefault()
    }

    copyToClipboard(event) {
        console.log("copyToClipboard called!")
        event.preventDefault()
        
        const button = event.currentTarget
        const textToCopy = button.getAttribute('data-value')
        
        if (textToCopy) {
            navigator.clipboard.writeText(textToCopy)
                .then(() => {
                    // Change icon to check mark briefly to indicate success
                    const icon = button.querySelector('i')
                    const originalClass = icon.className
                    
                    icon.className = 'fa-regular fa-circle-check document-app__icon document-app__icon--copy'
                    
                    // Revert back to original icon after 1.5 seconds
                    setTimeout(() => {
                        icon.className = originalClass
                    }, 1500)
                })
                .catch(err => {
                    console.error('Failed to copy: ', err)
                })
        }
    }

    handleDragOver(event) {
        console.log("handleDragOver called!")
        event.preventDefault()
    }

    handleDragEnter(event) {
        console.log("handleDragEnter called!")
        event.preventDefault()
    }

    handleDragLeave(event) {
        console.log("handleDragLeave called!")
        event.preventDefault()
    }

    handleDrop(event) {
        console.log("handleDrop called!")
        event.preventDefault()
    }

    showInfo(event) {
        console.log("showInfo called!")
        event.preventDefault()
    }

    closePanel(event) {
        console.log("closePanel called!")
        event.preventDefault()
        
        // Navigate back in history using the standard history API
        // This works with Turbo because Turbo hooks into the history API
        if (window.history && window.history.length > 1) {
            window.history.back()
        } else {
            // Fallback if there's no history
            Turbo.visit('/dashboard/document')
        }
    }
}